import {createReducer} from '../utils';
import {
    STATUS_PROJECT,
    STATUS_BUNDLE,
    STATUS_OPTION,
    STATUS_PAYMENT,
    STATUS_ORDER,
    STATUS_CHECKOUT,
    STATUS_CHECKOUT_DEP,
    STATUS_PRIVACY,
    STATUS_TEACHER,
    STATUS_TEACHER_PDF,
    STATUS_PAYEVER_CHANGE_PDF,
    STATUS_SEPA,
    STATUS_FINISH,
    STATUS_SUBMIT,
    STATUS_RESET,
    STATUS_SERIAL,
    STATUS_UPLOAD
} from '../constants';

const initialState = {
    project: {
        isset: false,
        name: '',
        data: {},
        teachers: false,
        isDep: false,
        requestSerial: false,
        id: 0
    },
    bundle: {
        isset: false,
        id: 0
    },
    options: {
        isset: false,
        articles: [],
        articleConfig: [],
        bundleId: 0
    },
    payment: {
        isset: false,
        id: '',
        type: '',
        group: '',
        paymentOption:'',
        paymentPrice:'',
        paymentRuntime:0,
        bundleId: 0
    },
    upload: {
        files: []
    },
    order: {
        isset: false,
        form: {}
    },
    privacy: {
        isset: false,
        checkbox: false
    },
    teacher: {
        isset: false,
        checkbox: false
    },
    requestSerial: {
        isset: false,
        sn: ''
    },
    teacherpdf: {
        shown: false
    },
    payeverchangepdf: {
        shown: true
    },
    checkout: {
        isset: false,
        checkbox: false
    },
    checkoutDep: {
        isset: false,
        checkboxes: []
    },
    finish: {
        isset: false
    },
    sepa: {
        isset: true,
        checkbox: true
    },
    submit: {
        status: '',
        data: {},
        msg: ''
    }
};

export default createReducer(initialState, {
    [STATUS_PROJECT]: (state, payload) => {
        return { ...state, project: payload }
    },
    [STATUS_SERIAL]: (state, payload) => {
        return { ...state, requestSerial: payload }
    },
    [STATUS_BUNDLE]: (state, payload) => {
        return { ...state, bundle: payload }
    },
    [STATUS_OPTION]: (state, payload) => {
        return { ...state, options: { ...state.options, ...payload } }
    },
    [STATUS_PAYMENT]: (state, payload) => {
        return { ...state, payment: payload }
    },
    [STATUS_ORDER]: (state, payload) => {
        return { ...state, order: payload }
    },
    [STATUS_CHECKOUT]: (state, payload) => {
        return { ...state, checkout: payload }
    },
    [STATUS_CHECKOUT_DEP]: (state, payload) => {
        return { ...state, checkoutDep: payload }
    },
    [STATUS_SEPA]: (state, payload) => {
        return { ...state, sepa: payload }
    },
    [STATUS_FINISH]: (state, payload) => {
        return { ...state, finish: payload }
    },
    [STATUS_PRIVACY]: (state, payload) => {
        return { ...state, privacy: payload }
    },
    [STATUS_TEACHER]: (state, payload) => {
        return { ...state, teacher: payload }
    },
    [STATUS_TEACHER_PDF]: (state, payload) => {
        return { ...state, teacherpdf: payload }
    },
    [STATUS_PAYEVER_CHANGE_PDF]: (state, payload) => {
        return { ...state, payeverchangepdf: payload }
    },
    [STATUS_UPLOAD]: (state, payload) => {
        return { ...state, upload: payload }
    },
    [STATUS_SUBMIT]: (state, payload) => {
        return { ...state, submit: payload }
    },
    [STATUS_RESET]: (state, payload) => {
        return initialState
    },
});



// WEBPACK FOOTER //
// ./src/reducers/status.js